// Objekt-Pool fuer den Hot Path.
//
// Die Simulation laeuft 60-mal pro Sekunde. Ein neues Objekt je Partikel
// bedeutet Ruckler durch Garbage Collection — genau in den Momenten mit vielen
// Partikeln, also genau dann, wenn es auffaellt (Gate FG-14).

export interface Poolable {
  dead: boolean;
}

export class Pool<T extends Poolable> {
  private readonly free: T[] = [];
  readonly active: T[] = [];

  constructor(private readonly factory: () => T) {}

  spawn(): T {
    const item = this.free.pop() ?? this.factory();
    item.dead = false;
    this.active.push(item);
    return item;
  }

  /** Tote Eintraege zurueck in den Vorrat — ohne die Reihenfolge zu erhalten. */
  sweep(): void {
    const list = this.active;
    for (let i = list.length - 1; i >= 0; i--) {
      if (list[i].dead) {
        this.free.push(list[i]);
        list[i] = list[list.length - 1];
        list.pop();
      }
    }
  }

  get length(): number {
    return this.active.length;
  }

  forEach(fn: (item: T, index: number) => void): void {
    for (let i = 0; i < this.active.length; i++) fn(this.active[i], i);
  }

  clear(): void {
    for (const item of this.active) this.free.push(item);
    this.active.length = 0;
  }
}
